import React, { useEffect } from 'react';
import styles from '../../styles/cards.module.css'
import { comiteEtica } from '../../json/comiteEtica';

const ComiteEtica = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container transparencia-container'>
            <div className='row'>
                <div className='col_12'>
                    <div className='transparencia_title'>
                        <h3 className={ styles.title }>
                            Comité de Ética y Prevención de Conflictos de Interés
                        </h3>
                        <hr className='hr-gob'></hr>
                    </div>
                </div>
                <div className={styles.btnLink}>
                    <a className={styles.tagLink} href='https://s-infraestructura.hidalgo.gob.mx/digital_files/CEPCI/comite-CEPCI-2026.pdf' target='_blank' rel='noopener noreferrer'>
                        <div className={styles.iconbtn}>
                            <i className='icon-logbook-2'></i>
                        </div>
                        <div className={styles.nameBtn}>
                            <p className={styles.textNameBtn}>Directorio de Integrantes del Comité de Ética y Prevención de Conflictos de Interés</p>
                        </div>
                    </a>
                </div>
                {
                    comiteEtica.map((item, index)=>(
                        <div key={ index } className='col-md-3 col-sm-6 col-12'>
                            <div className={styles.container}>
                                <h5 className={styles.name}>
                                    {item.anio}
                                </h5>
                                <hr></hr>
                                {
                                    item.archivos.map((archivo, index) => (
                                        <div key={ index }>
                                            {archivo.urlPrograma && (
                                                <a className={styles.link} href={archivo.urlPrograma} target='_blank' rel='noopener noreferrer'>
                                                    <div className={styles.item}>
                                                        <p className={styles.textLink}>{archivo.name}
                                                            {archivo.programa}
                                                        </p>
                                                        <i className={`icon-file-pdf ${styles.iconLink}`} aria-hidden='true'></i>
                                                    </div>
                                                </a>
                                            )}
                                            {archivo.urlInforme && (
                                                <a className={styles.link} href={archivo.urlInforme} target='_blank' rel='noopener noreferrer'>
                                                    <div className={styles.item}>
                                                        <p className={styles.textLink}>
                                                            {archivo.informe}
                                                        </p>
                                                        <i className={`icon-file-pdf ${styles.iconLink}`} aria-hidden="true"></i>
                                                    </div>
                                                </a>
                                            )}
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default ComiteEtica